import { useState } from "react";
import { Loading } from "../layout";
import { ShowAlert } from "../utils/alerts";
import { Hide } from "../utils/hide";
import { ShowImage } from "../utils/image";
import { Tree } from "../utils/tree";

export const Form = ({ data = {}, alert, setup = false, features = [], status = [], countries = [], onChange }) => {
    const [photoState, setPhotoState] = useState(true);
    const disabled = onChange == null;
    let photoInput = null;
    const renderFeature = (node) => {
        return <div className="border-bottom">
            <span>{node.name}</span>
            <Hide state={!node.mod}>
                <input onChange={onChange} value={node.mod} disabled={disabled} checked={data.features?.split(",").filter(f => f === node.mod).length || false} name="features" type="checkbox" className="float-end" />
            </Hide>
        </div>
    }
    const selectPhoto = () => {
        if (disabled) return;
        setPhotoState(false);
        photoInput.click();
        setPhotoState(true);
    }
    return (
        <div className="row">
            <div className="col-lg-4 col-xl-3">
                <div className="card mb-3">
                    <div onClick={selectPhoto} className="card-body text-center shadow d-flex justify-content-center align-items-center link" style={{ height: "342.203px" }}>
                        <input ref={el => { photoInput = el }} onChange={onChange} type="file" name="photo" hidden={photoState} multiple={false} />
                        <ShowImage className="rounded img-fluid h-100" src={data.photo} domain={data.domain} preview={data.preview} style={{ objectFit: "contain" }} alt="logo" />
                    </div>
                </div>
            </div>
            <div className="col-lg-8 col-xl-9">
                <div className="card shadow mb-3">
                    <div className="card-header py-3">
                        <p className="text-primary m-0 fw-bold">Basic Information</p>
                    </div>
                    <div className="card-body">
                        <ShowAlert alerts={alert} tag="error" />
                        <div className="row">
                            <div className="col-md-6">
                                <label className="col-form-label w-100">
                                    <strong>Name</strong>
                                    <input onChange={onChange} value={data.name || ""} disabled={disabled} name="name" type="text" className="form-control" placeholder="Company Name" />
                                </label>
                                <ShowAlert alerts={alert} tag="name_error" />
                            </div>
                            <div className="col-12 col-md-6">
                                <label className="col-form-label w-100">
                                    <strong>Slog</strong>
                                    <input onChange={onChange} value={data.slog || ""} disabled={disabled} name="slog" type="text" className="form-control" placeholder="Slog" />
                                </label>
                                <ShowAlert alerts={alert} tag="slog_error" />
                            </div>
                            <div className="col-md-6">
                                <label className="col-form-label w-100">
                                    <strong>Tag</strong>
                                    <input onChange={onChange} value={data.tag || ""} disabled={disabled} name="tag" type="text" className="form-control" placeholder="tag" />
                                </label>
                                <ShowAlert alerts={alert} tag="tag_error" />
                            </div>
                            <div className="col-md-6">
                                <label className="col-form-label w-100">
                                    <strong>Domain</strong>
                                    <input onChange={onChange} value={data.domain || ""} disabled={disabled} name="domain" type="text" className="form-control" placeholder="tag.example.com" />
                                </label>
                                <ShowAlert alerts={alert} tag="domain_error" />
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <label className="col-form-label w-100">
                                    <strong>Status</strong>
                                    <select onChange={onChange} value={data.status || ""} disabled={disabled || data.root} name="status" className="form-select">
                                        {status.map((v, i) => <option key={i} value={i}>{v}</option>)}
                                    </select>
                                </label>
                                <ShowAlert alerts={alert} tag="status_error" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col">
                <Hide state={setup}>
                    <div className="card shadow mb-3">
                        <div className="card-header py-3">
                            <p className="text-primary m-0 fw-bold">Contact Person</p>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6 col-xl-4">
                                    <label className="col-form-label w-100">
                                        <strong>First Name</strong>
                                        <input onChange={onChange} value={data.fname || ""} disabled={disabled} name="fname" type="text" className="form-control" placeholder="First Name" />
                                    </label>
                                    <ShowAlert alerts={alert} tag="fname_error" />
                                </div>
                                <div className="col-md-6 col-xl-4">
                                    <label className="col-form-label w-100">
                                        <strong>Last Name</strong>
                                        <input onChange={onChange} value={data.lname || ""} disabled={disabled} name="lname" type="text" className="form-control" placeholder="Last Name" />
                                    </label>
                                    <ShowAlert alerts={alert} tag="lname_error" />
                                </div>
                                <div className="col-md-6 col-xl-4">
                                    <label className="col-form-label w-100">
                                        <strong>Middle Name</strong>
                                        <input onChange={onChange} value={data.mname || ""} disabled={disabled} name="mname" type="text" className="form-control" placeholder="Middle Name" />
                                    </label>
                                </div>
                                <div className="col-md-6 col-xl-4">
                                    <label className="col-form-label w-100">
                                        <strong>Phone</strong>
                                        <input onChange={onChange} value={data.phone || ""} disabled={disabled} name="phone" type="text" className="form-control" placeholder="phone" />
                                    </label>
                                    <ShowAlert alerts={alert} tag="phone_error" />
                                </div>
                                <div className="col-md-6 col-xl-8">
                                    <label className="col-form-label w-100">
                                        <strong>Email</strong>
                                        <input onChange={onChange} value={data.email || ""} disabled={disabled} name="email" type="text" className="form-control" placeholder="email" />
                                    </label>
                                    <ShowAlert alerts={alert} tag="email_error" />
                                </div>
                            </div>
                        </div>
                    </div>
                </Hide>
                <Hide state={setup}>
                    <div className="card shadow mb-3">
                        <div className="card-header py-3">
                            <p className="text-primary m-0 fw-bold">Location</p>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-12 col-xxl-9">
                                    <label className="col-form-label w-100">
                                        <strong>Address</strong>
                                        <input onChange={onChange} value={data.address1 || ""} disabled={disabled} name="address1" type="text" className="form-control" placeholder="Address" />
                                    </label>
                                    <ShowAlert alerts={alert} tag="address1_error" />
                                </div>
                                <div className="col-12 col-xxl-3">
                                    <label className="col-form-label w-100">
                                        <strong>Apt/Unit</strong>
                                        <input onChange={onChange} value={data.address2 || ""} disabled={disabled} name="address2" type="text" className="form-control" placeholder="Apt/Unit" />
                                    </label>
                                </div>
                                <div className="col-md-6">
                                    <label className="col-form-label w-100">
                                        <strong>City</strong>
                                        <input onChange={onChange} value={data.city || ""} disabled={disabled} name="city" type="text" className="form-control" placeholder="City" />
                                    </label>
                                    <ShowAlert alerts={alert} tag="city_error" />
                                </div>
                                <div className="col">
                                    <label className="col-form-label w-100">
                                        <strong>Country</strong>
                                        <select onChange={onChange} value={data.country_id || ""} disabled={disabled} className="form-select" name="country_id">
                                            <option value="">Select Country</option>
                                            {countries.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                                        </select>
                                    </label>
                                    <ShowAlert alerts={alert} tag="country_id_error" />
                                </div>
                                <div className="col-md-6">
                                    <label className="col-form-label w-100">
                                        <strong>State / Province</strong>
                                        <input onChange={onChange} value={data.state || ""} disabled={disabled} name="state" type="text" className="form-control" placeholder="State/Province" />
                                    </label>
                                    <ShowAlert alerts={alert} tag="state_error" />
                                </div>
                                <div className="col">
                                    <label className="col-form-label w-100">
                                        <strong>Zip Code</strong>
                                        <input onChange={onChange} value={data.zip_code || ""} disabled={disabled} name="zip_code" type="text" className="form-control" placeholder="Zip Code" />
                                    </label>
                                    <ShowAlert alerts={alert} tag="zip_code_error" />
                                </div>
                            </div>
                        </div>
                    </div>
                </Hide>
                <Hide state={setup}>
                    <div className="card shadow mb-3">
                        <div className="card-header py-3">
                            <p className="text-primary m-0 fw-bold">Features</p>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-12">
                                    {!features.length && <Loading />}
                                    <Tree nodes={features} nrender={renderFeature} childKey={"features"} />
                                </div>
                            </div>
                        </div>
                    </div>
                </Hide>
                <div className="card shadow mb-3">
                    <div className="card-header py-3">
                        <p className="text-primary m-0 fw-bold">Subscription</p>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-6 col-xl-4">
                                <Hide state={!setup}>
                                    <label className="form-label w-100">
                                        <strong>Setup Key</strong>
                                        <input onChange={onChange} value={data.setup_key || ""} type="text" className="form-control" name="setup_key" placeholder="Provide the key in your config file" />
                                    </label>
                                </Hide>
                                <Hide state={setup}>
                                    <h1>{status[data.status]}</h1>
                                </Hide>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
}
